import { NO_PERMISSION_PATH, REPORT_RESULT, ROOT } from 'constant/path';
import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAppSelector } from 'reducers/models';

interface IReportProtectedWrapper {
  children: React.ReactNode;
}

const ReportProtectedWrapper: React.FC<IReportProtectedWrapper> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoading = useAppSelector((state) => state.auth.isLoading);
  const userGroupAuthorization = useAppSelector((state) => state.auth.userGroupAuthorization);
  const userAuthorization = useAppSelector((state) => state.auth.userAuthorization);
  const questionBankAuthorization = useAppSelector((state) => state.auth.questionBankAuthorization);
  const surveyAuthorization = useAppSelector((state) => state.auth.surveyAuthorization);
  const isNoPermissionUserGroupRole = useMemo(
    () => userGroupAuthorization.every((role) => !role.isPermission),
    [JSON.stringify(userGroupAuthorization)]
  );
  const isNoPermissionUserRole = useMemo(
    () => userAuthorization.every((role) => !role.isPermission),
    [JSON.stringify(userAuthorization)]
  );
  const isNoPermissionQuestionBankRole = useMemo(
    () => questionBankAuthorization.every((role) => !role.isPermission),
    [JSON.stringify(questionBankAuthorization)]
  );
  const isNoPermissionSurveyRole = useMemo(
    () => surveyAuthorization.every((role) => !role.isPermission),
    [JSON.stringify(surveyAuthorization)]
  );

  const handleNavigate = () => {
    const currentPathName = location.pathname;
    if (isLoading) {
      return;
    }
    if (
      currentPathName.includes(REPORT_RESULT) &&
      isNoPermissionQuestionBankRole &&
      isNoPermissionUserRole &&
      isNoPermissionUserGroupRole &&
      isNoPermissionSurveyRole
    ) {
      navigate(`${ROOT}${NO_PERMISSION_PATH}`);
      return;
    }
  };
  useEffect(() => {
    handleNavigate();
  }, [location.pathname, isLoading]);

  return <>{children}</>;
};

export default ReportProtectedWrapper;
